import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`

`

const WelcomePage = () => {
    return (
        <Container>
            <h2>Welcome</h2>
            <Link to='/intake'>Begin Intake</Link>
        </Container>
    )
}

export default WelcomePage;